import React, { memo, useRef } from "react";
import clsx from "clsx";
import { shallowEqual } from "react-redux";
import { CarConfigConfigureSectionsLbx } from "../../../../../utils/types/SectionTypesLbx";
import SectionWrapper, { type SectionWrapperPropagationProps } from "../../../common/section-wrapper/SectionWrapper";
import Pack from "./Pack";
import Cta from "./Cta";
import Text from "../../../../../../shared-components/css-modules/lexus/atoms/Text";
import Container from "../../../../../../shared-components/css-modules/lexus/atoms/Container";
import slider from "../../../../../../shared-components/css-modules/lexus/utils/DraggableSlider.module.scss";
import styles from "./Packs.module.scss";
import { useSlider } from "../../../../../../../../common-deprecated/features/apheleia/hooks/useSlider";
import { useCarConfigSelector } from "../../../../../redux/store";
import { selectCurrentAtmosphereGroupIndex } from "../../../../../redux/slices/CarConfigAtmosphereSlice";
import { CarConfigLabel } from "../../../../../utils/labelUtils";

const Packs: React.FC<SectionWrapperPropagationProps<CarConfigConfigureSectionsLbx>> = ({
    sectionRefs,
}): JSX.Element => {
    const wrapperRef = useRef<HTMLDivElement | null>(null);
    const anyItemRef = useRef<HTMLDivElement | null>(null);
    const packs = useCarConfigSelector((state) => state.items.packs);
    const showCta = useCarConfigSelector(selectCurrentAtmosphereGroupIndex, shallowEqual) === 0;

    const { elementProps, isDragging } = useSlider(wrapperRef, anyItemRef);
    return (
        <SectionWrapper
            sectionId={CarConfigConfigureSectionsLbx.Packs}
            sectionRef={sectionRefs.get(CarConfigConfigureSectionsLbx.Packs)}
        >
            <Container>
                <Text tag="h2" variant="apheleia-h3" spacing="spacing-6">
                    <CarConfigLabel label="carConfigLbxPacksTitle" />
                </Text>
            </Container>
            <div
                className={clsx(slider.wrapper, styles.slider, isDragging && slider.dragging)}
                ref={wrapperRef}
                {...elementProps}
            >
                {packs.map((pack, index) => (
                    <Pack key={pack.id} pack={pack} index={index} />
                ))}
                {/* Only show Cta component if the base atmosphere is selected */}
                {showCta && <Cta index={2} />}
            </div>
        </SectionWrapper>
    );
};

export default memo(Packs);
